import React from 'react';
import { useSelector } from 'react-redux';
import { Form, Select } from 'ui/components';

import _ from 'underscore';

const ppnOptions = [
  { value: 11, label: 'PPn 11' },
  { value: 1.1, label: 'PPn 1.1' },
  { value: 2, label: 'PPh 23' },
  { value: 9, label: 'PPn + PPh 23' },
  { value: 10, label: 'PPn 10' },
  { value: 1, label: 'PPn 1' },
];

const initialState = {
  base_price: 0,
  base_tax: null,
  unit_price: 0,
  unit_tax: null,
};

export const FormPrice = ({ product, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    { base_price, base_tax, unit_price, unit_tax },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    const input = {
      base_price,
      base_tax: base_tax?.value,
      unit_price,
      unit_tax: unit_tax?.value,
    };

    onInputChange(input);
  }, [base_price, base_tax, unit_price, unit_tax]);

  React.useEffect(() => {
    if (!product) return;

    let bt = null
    let ut = null

    _.each(ppnOptions, function(i) {
      if (i?.value === product?.base_tax) {
        bt = i
      }

      if (i?.value === product?.unit_tax) {
        ut = i
      }
    })

    setState((prevState) => ({
      ...prevState,
      base_price: product?.base_price,
      base_tax: bt,
      unit_price: product?.unit_price,
      unit_tax: ut,
    }));
  }, [product]);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Informasi Harga</div>
      <div className="py-3">
        <div className='row'>
          <div className='col-6'>
            <Form.Input
              label="Harga Beli"
              type="number"
              value={base_price}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  base_price: e.target.valueNumber,
                }))
              }
              error={StateForm?.errors?.base_price}
            />
          </div>

          <div className='col-6'>
            <div className="mb-3">
                <label className="form-label">Pilih Pajak Beli</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.base_tax
                      ? 'is-invalid'
                      : 'select'
                  }
                  placeholder=""
                  value={base_tax}
                  options={ppnOptions}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      base_tax: e,
                    }))
                  }
                  error={StateForm?.errors?.base_tax}
                />

                {StateForm?.errors?.base_tax ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.base_tax}
                  </div>
                ) : null}
              </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-6'>
            <Form.Input
              label="Harga Jual"
              type="number"
              value={unit_price}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  unit_price: e.target.valueNumber,
                }))
              }
              error={StateForm?.errors?.unit_price}
            />
          </div>

          <div className='col-6'>
            <div className="mb-3">
                <label className="form-label">Pilih Pajak Jual</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.unit_tax
                      ? 'is-invalid'
                      : 'select'
                  }
                  placeholder=""
                  value={unit_tax}
                  options={ppnOptions}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      unit_tax: e,
                    }))
                  }
                  error={StateForm?.errors?.unit_tax}
                />

                {StateForm?.errors?.unit_tax ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.unit_tax}
                  </div>
                ) : null}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};
